import React from "react";
import './style.scss';

type Props = {
    onComplete?: () => void
}

type Item = {
    label: string,
    src: string,
    correct?: boolean,
}

const TaskGame8: React.FunctionComponent<Props> = () => {

    const data : Item[] = [
        {
            label: 'ojciec',
            src: `${process.env.PUBLIC_URL}/tasks/task-8/image1.jpg`,
            correct: true
        },
        {
            label: 'modelka',
            src: `${process.env.PUBLIC_URL}/tasks/task-8/image4.jpg`
        },    
       
        {
            label: 'kobieta na quadzie',
            src: `${process.env.PUBLIC_URL}/tasks/task-8/image2.jpg`,
            correct: true
        },
        {
            label: 'majster',
            src: `${process.env.PUBLIC_URL}/tasks/task-8/image5.jpg`
        },
        {
            label: 'mała szachistka',
            src: `${process.env.PUBLIC_URL}/tasks/task-8/image3.jpg`,
            correct: true
        },        
        {
            label: 'pan nauczyciel w lesie',
            src: `${process.env.PUBLIC_URL}/tasks/task-8/image6.jpg`,
            correct: true
        },
        {
            label: 'lekarz + pielęgniarka',
            src: `${process.env.PUBLIC_URL}/tasks/task-8/image7.jpg`
        }
    ]

    return (
        <ul className="task-game-8">
            {data.map((i, index) => {
                return (
                    <li>
                        <label className={`${i.correct? 'correct' : 'wrong'}`}>
                            <input type="checkbox" />
                            <figure className="game-item">
                                <img src={i.src} alt="i.label" />
                                {/* <figcaption>{i.label}</figcaption> */}
                            </figure>
                        </label>
                    </li>
                )
            })}
        </ul>
    )
}

export default TaskGame8;
